import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionFeatureSystemsComponent } from '../userAction-featureSystem/userAction-featureSystem.component';
import { FeatureToBeRenamed } from '../../../../Model/Catalog/FeatureModels/FeatureToBeRenamedModel';
import { ValidFeatureSystem } from '../../../../Model/ValidFeatureSystem';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { UserActionBaseComponent } from '../userAction-base.component';
import { Macro } from 'app/Model/ui/Macro';
import { SystemService } from 'app/Services/system.service';

@Component({
  selector: 'userAction-removeValuelists',
  templateUrl: 'userAction-removeValuelists.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionRemoveValuelistsComponent) }
  ]
})
export class UserActionRemoveValuelistsComponent extends UserActionFeatureSystemsComponent {
  featuresGridDataSource: Array<FeatureToBeRenamed> = [];
  selectedFeatureSystem: ValidFeatureSystem;
  featuresLoading = false;
  removeFromCategories = false;
  removeFromProduct = false;
  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public systemService: SystemService,
    public catalogService: CatalogService,
    validFeatureService: ValidFeatureService
  ) {
    super(loginService, macroService, catalogService, validFeatureService);
  }

  onFeatureSystemChanged(e) {
    this.featuresGridDataSource = [];
    if (this.selectedFeatureSystem) {
      this.featuresLoading = true;     
      this.loadFeatures(this.selectedFeatureSystem).then((features) => {
        for (let feature of features) {          
          this.featuresGridDataSource.push(new FeatureToBeRenamed(feature, '', ''));
        }
        this.featuresLoading = false;
      });
    }
  }

  public async canStartMacro() : Promise<boolean>{
    if (this.removeFromProduct == false && this.removeFromCategories == false) {
      this.systemService.notifyInfo(this.translate.instant("Bitte mindestens einen Filter wählen"));
      return false;
    }

    return true
  }

  createUserAction(): StartAction {
    let userAction = new StartAction();
    userAction.catalogId = this.catalogService.catalog.id;
    userAction.customerId = this.loginService.currentUser.customerId;
    userAction.actionId = `RenameFeatures(${this.createParameterStringAsJsonString()})`;
    return userAction;
  }

  createParameterStringAsJsonString(): string {
    let parameterJsonString = JSON.stringify({
      removeFromCategories: this.removeFromCategories,
      removeFromProduct: this.removeFromProduct
    });
    return parameterJsonString;
  }

  parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.removeFromProduct = parsed.removeFromProduct;
      this.removeFromCategories = parsed.removeFromCategories;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }


}
